<template>
  <div style="max-height: 500px;overflow: auto">
    <div ref="editRef" />
  </div>
</template>

<script>
import { AiEditor } from "aieditor";
import "aieditor/dist/style.css"
export default {
  name: "",
  components: { AiEditor },
  props: {
    value: {
      type: String,
      default: ""
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      editor: null,
    };
  },
  computed: {
    editorContent: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
  },
  methods: {},
  mounted(){
    let that = this
    this.editor = new AiEditor({
      element: that.$refs.editRef,
      toolbarSize: 'small',
      placeholder: "点击输入内容...",
      content: that.editorContent,
      editable: that.editable,
      onChange:(aiEditor)=>{
        that.$emit("input", aiEditor.getHtml());
      }
    })
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy()
  }
};
</script>

